import type {
  AlloyLegacyThemeDesignTokens,
  ProgressRingDesignTokens,
} from '../types';
import { Weave3ProgressRingInput } from '../types/weave3Types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getProgressRingTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): ProgressRingDesignTokens => ({
  'icon-color': {
    default: theme.tokens.colors.icon.load.value,
    inverse: theme.tokens.colors.icon.inverse.value,
  },
  'icon-color-light': {
    default: theme.tokens.colors.icon.load.value,
    inverse: theme.tokens.colors.icon.inverse.value,
  },
});

export const getProgressRingTokensWeave = (
  tokens: WeaveTokens,
): ProgressRingDesignTokens => ({
  ...tokens?.component?.progressring,
  'icon-color': {
    default: tokens?.component?.progressring?.['dark-ring']?.fill,
    inverse:
      tokens?.component?.progressring?.['solid-contrast']?.['dark-ring']?.fill,
  },
  'icon-color-light': {
    default: tokens?.component?.progressring?.['light-ring']?.fill,
    inverse:
      tokens?.component?.progressring?.['solid-contrast']?.['light-ring']?.fill,
  },
});

export const getProgressRingTokensWeave3 = (
  progressring?: Weave3ProgressRingInput,
): ProgressRingDesignTokens => ({
  ...progressring,
  'icon-color': {
    default: progressring?.['dark-ring']?.fill,
    inverse: progressring?.['solid-contrast']?.['dark-ring']?.fill,
  },
  'icon-color-light': {
    default: progressring?.['light-ring']?.fill,
    inverse: progressring?.['solid-contrast']?.['light-ring']?.fill,
  },
});
